/* src/data/translateMeta.js
   번역 시스템 공용 메타데이터 (언어 · 모델 정의) */

/* ================= 언어 목록 ================= */
export const LANGS = [
  { code: "auto", label: "감지" },
  { code: "korean", label: "한국어" },
  { code: "japanese", label: "日本語" },
  { code: "english", label: "English" },
  { code: "chinese", label: "中文" },
  { code: "vietnamese", label: "Tiếng Việt" },
];

/* ================= LLM 모델 ==================
   ─ 이름(key)  ─ label(표시용)  ─ desc(설명) */
export const MODELS = {
  "TGL-51X": {
    label: "TGL-51X",
    desc: "완전성 최우선. 51명의 전문가가 긴 문서를 세밀히 분석하지만 처리 속도는 가장 느립니다.",
  },
  "TGL-23X": {
    label: "TGL-23X",
    desc: "균형형. 23명의 전문가로 빠른 처리 속도와 우수한 품질을 동시에 제공합니다.",
  },
  "TGL-8X": {
    label: "TGL-8X",
    desc: "속도 최우선. 8명의 전문가가 초고속 응답을 제공하며 충분히 높은 정확도를 유지합니다.",
  },
};

export const RAG_MODELS = {
  "GRD-16X12B": {
    label: "GRD-16X12B",
    desc: "완전성과 정확성을 최우선으로 보장합니다. 16명의 전문가가 참여하여 깊이 있는 전문 문서를 이해하고 처리합니다.",
  },
  "GRD-8X12B": {
    label: "GRD-8X12B",
    desc: "효율성과 전문성의 균형을 추구합니다. 8명의 전문가가 대부분의 기업용 복잡 문서를 원활하게 이해하고 처리합니다.",
  },
  "GRD-4X12B": {
    label: "GRD-4X12B",
    desc: "처리 속도를 극대화합니다. 4명의 전문 인력이 신속하면서도 균형 있게 다양한 문제를 해결합니다.",
  },
};
